module.exports = __webpack_public_path__ + "img/21.dff9079c.jpg";